import { FunctionComponent, useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'

import List from 'design-system/Iconography/SVG/List'
import Map from 'design-system/Iconography/SVG/Map'
import Body4 from 'design-system/Typography/Body/Body4'

import Spacer from 'components/Spacer'

import { capitalizeWord } from 'utils/stringFormatting'

interface IViewModeProp {
  viewMode: 'map' | 'list'
}
const ModeButton = styled.div<IViewModeProp>`
  position: absolute;
  bottom: ${props => props.theme.spacings[16]}px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  background: ${props => props.theme.colors.white};
  display: flex;
  align-items: center;
  box-shadow: ${props => props.theme.shadows.neutral.level3};
  border-radius: ${props => props.theme.radii[4]}px;
  padding: ${props => props.theme.spacings[12]}px ${props => props.theme.spacings[8]}px;
`

interface IProps {
  mode: 'map' | 'list'
  toggleMode: () => void
}

const MapListModeButton: FunctionComponent<IProps> = ({ mode, toggleMode }) => {
  const theme = useContext(ThemeContext)

  return (
    <ModeButton
      onClick={toggleMode}
      viewMode={mode}
    >
      {mode === 'list'
        ? (
          <Map fill={theme.colors.neutral500} />
        )
        : (
          <List fill={theme.colors.neutral500} />
        )}
      <Spacer size={theme.spacings[8]} />
      <Body4 color="neutral500">{capitalizeWord(mode === 'list' ? 'map' : 'list')}</Body4>
    </ModeButton>
  )
}

export default MapListModeButton
